export const profileBasicPlan = {
  id: 'basico',
  tier: 'Básico',
  priceLabel: 'Gratis',
  isCurrent: true,
  features: [
    {
      title: 'Acceso limitado a proveedores',
      items: [
        'Solo puedes ver información de proveedores Premium.',
        'Limitado a visualizar detalles de hasta 3 proveedores por día.',
      ],
    },
    {
      title: 'Información Restringida',
      items: [
        'Precios de servicios aparecen difuminados',
        'Sin acceso a contactos directos de proveedores',
      ],
    },
    {
      title: 'Sin Uso de Cupones',
      items: [
        'Puedes ver las promociones disponibles, pero no puedes redimir cupones de descuento',
      ],
    },
    {
      title: 'Sin Interacción con Proveedores',
      items: [
        'No puedes enviar comentarios ni preguntas',
        'No es posible calificar o dejar reseñas',
      ],
    },
    {
      title: 'Notificaciones Restrictivas',
      items: [
        'Solo puedes leer una notificación PUSH por día',
        'Las demás notificaciones quedan bloqueadas hasta suscribirte al plan Premium',
      ],
    },
  ],
};

export const profilePremiumPlan = {
  id: 'premium',
  tier: 'Premium',
  priceLabel: 'Premium',
  isCurrent: false,
};

export const getProfileSubscriptionPlan = (planId) => {
  if (planId === 'premium') {
    return {
      ...profilePremiumPlan,
      isCurrent: true,
    };
  }

  return profileBasicPlan;
};
